

export const LOADER_STATUS = 'LOADER_STATUS';
export const SET_MASTER_MODULE = 'SET_MASTER_MODULE';
export const SET_ADD_MODULE_MODAL = 'SET_ADD_MODULE_MODAL';